// extracted by mini-css-extract-plugin
export default {"image-container":"Video_image-container__AKrvG"};